import { render, staticRenderFns } from "./ManufactureList.vue?vue&type=template&id=5ed9170a&scoped=true"
import script from "./ManufactureList.vue?vue&type=script&lang=js"
export * from "./ManufactureList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed9170a",
  null
  
)

export default component.exports